import { ActionBody } from './components/ActionBody'
import { ActionForm } from './components/ActionForm'
import { ActionHeader } from './components/ActionHeader'
import { CreateActionProvider } from './contexts/action'

export function CreateActionPage() {
  return (
    <CreateActionProvider>
      <ActionForm>
        <div style={{ position: 'sticky' }}>
          <ActionHeader />
        </div>
        <div style={{ overflow: 'auto', height: 'calc(100vh - 50px)', paddingBottom: '80px' }}>
          <ActionBody />
        </div>
      </ActionForm>
    </CreateActionProvider>
  )
}
